import { connect } from 'react-redux';
import { lifecycle, compose } from 'recompose';

import { isLogin, myProfile } from '../../Redux/user-profile/selectors';
import { getProfile } from '../../Redux/user-profile/actions';
import { withCapacitor } from '../../Util/Capacitors/hoc';

import RouteApp from './RouteApp';

const mapStateToProps = (state) => ({
  isLogin: isLogin(state),
  myProfile: myProfile(state),
});

const doValidate = lifecycle({
  componentDidMount() {
    this.props.getProfile();
  },
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.myProfile !== this.props.myProfile) {
      const { setUserInfo } = this.props.capacitorContext;
      setUserInfo(this.props.myProfile);
    }
  },
});

export default compose(
  connect(mapStateToProps, { getProfile }),
  withCapacitor,
  doValidate
)(RouteApp);
